// project import
import MainLayout from 'layout/MainLayout';
import CloudLayout from 'layout/CloudLayout';
import LoginGuard from 'layout/LoginLayout/guard';

type Props = {
  variant: string;
};
const LoginLayout = (props: Props) => {
  const { variant } = props;
  return <LoginGuard>{variant === 'cloud' ? <CloudLayout /> : <MainLayout />}</LoginGuard>;
};

export default LoginLayout;
